import React from 'react';
import { Segmented } from '@bettercomp/ui-components';
import { BenchmarkStatus } from 'types';

export const BENCHMARK_OPTIONS = {
  all: { value: BenchmarkStatus.ALL, label: 'All' },
  benchmark: { value: BenchmarkStatus.BENCHMARK, label: 'Benchmark' },
  nonBenchmark: { value: BenchmarkStatus.NON_BENCHMARK, label: 'Non Benchmark' },
};

type BenchmarkStatusSelectorProps = {
  value: BenchmarkStatus,
  onChange: (value: BenchmarkStatus) => void,
};

export const BenchmarkStatusSelector = ({ value, onChange }: BenchmarkStatusSelectorProps) => {
  return (
    <Segmented
      value={value}
      options={Object.values(BENCHMARK_OPTIONS)}
      onChange={(v) => onChange(v as BenchmarkStatus)}
      data-testid="benchmarkSelector"
    />
  );
};
